import urlJoin from 'url-join'

export function buildUrls(data: { accountServerBase: string, backofficeUri: string }) {
    return {
        getCarsiSuspect: urlJoin(data.accountServerBase, '/user-service/carsi-suspect/${tenantUserId}'),
    }
}

export type IUrls = ReturnType<typeof buildUrls>